import React, { Component, Fragment, useEffect, useCallback, useState, useRef } from 'react';
import './style.css';
import { Link, useHistory, useLocation, Redirect } from "react-router-dom";
import { Layout, Menu, Breadcrumb, Table, Modal, Button, Space, Form, Input, Row, Col, Checkbox, Switch, Divider, Card, Radio, Spin, Collapse, Select, Typography, Popconfirm } from 'antd';
import { MinusCircleOutlined, PlusOutlined, SearchOutlined, MoreOutlined, SyncOutlined, EditOutlined, SettingOutlined, EyeOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import Container from '../Layout/Container';
import { Wizard, Steps, Step } from 'react-albus';
import { useSelector, useDispatch } from 'react-redux';
import { viewEditBranchAsyn, getSeenStampForAdminAsyn, updateSeenStampForAdminAsyn, addDrAsyn, updateDrStatusAsyn, updateBranchAsyn, viewEditBranchSelector, editBrAsyn, updateBrOnlyAsyn, clearState, responseState, clearResponseState, responseBrState, clearBrResponseState } from './viewEditBranchSlice';

import toast, { Toaster, ToastBar } from 'react-hot-toast';
import FormBuilder from 'antd-form-builder';
import Can from '../../config/Can';
import { RiDeleteBinLine } from 'react-icons/ri';
import { AiOutlineSave } from 'react-icons/ai';
const { Header, Content, Footer } = Layout;
const { Search, TextArea } = Input;
const { Option } = Select;
const CheckboxGroup = Checkbox.Group;
const antIcon = <SyncOutlined style={{ fontSize: 24 }} spin />;
const { Panel } = Collapse;
const { Paragraph } = Typography;


export default function ViewEditBranch() {
  const inputAddBranch = React.useRef(null);
  const [isToast, setToast] = React.useState(false);
  const [isLoading, setLoading] = React.useState(false);
  const [isDirectorate, setDirectorate] = React.useState(true);
  const dispatch = useDispatch();
  let history = useHistory();
  const [state, setState] = useState({})
  const [dBranch, setdBranch] = useState(null)
  const [bDirectorate, setbDirectorate] = useState(null)
  const location = useLocation();
  const [expand, setExpand] = React.useState(false);
  const [counter, setCounter] = React.useState(0);
  const [expandable, setExpandable] = React.useState(true);

  const [drexpand, setdrExpand] = React.useState(false);
  const [drcounter, setdrCounter] = React.useState(0);
  const [drexpandable, setdrExpandable] = React.useState(true);

  const { isFetching, isSuccess, isError, errorMessage, branch, isResponse, seenStampData, isBrResponse, brName } = useSelector(
    viewEditBranchSelector
  );

  const MOCK_INFO = {
    name: '',
    referenceNumber: [],
    //referenceNumber: 'hi',
    description: '',
  }



  const [form] = Form.useForm()
  const [formDr] = Form.useForm()
  const formRef = useRef(null);
  const formDrRef = useRef(null);
  const forceUpdate = FormBuilder.useForceUpdate();
  const [viewMode, setViewMode] = useState(true)
  const [pending, setPending] = useState(false)
  // const [personalInfo, setPersonalInfo] = useState(MOCK_INFO)
  const [personalInfo, setPersonalInfo] = useState(MOCK_INFO)

  const [viewModeDr, setViewModeDr] = useState(true)
  const [openPanel, setopenPanel] = useState(0)
  const branchname = localStorage.getItem('deptTypeName') ? localStorage.getItem('deptTypeName') : location.state.branchName;
  useEffect(() => {
    dispatch(clearState());
    setLoading(true);
    if (location.state.branchName) {
      localStorage.setItem('deptTypeName', location.state.branchName);
    }


    //let departmentName = localStorage.getItem('deptTypeName');
    const departmentName = localStorage.getItem('deptTypeName') ? localStorage.getItem('deptTypeName') : location.state.branchName;

    let bData = {
      code: "b",
      deptTypeName: departmentName,
      departmentName: "Chief of Air Staff"
    };

    dispatch(viewEditBranchAsyn(bData)).then(() => {
      setLoading(false);
    });
    // setTimeout(() => {
    //   setDirectorate(true);
    // }, 5000);
    dispatch(getSeenStampForAdminAsyn());
  }, []);

  const setBrStorage = (br) => {
    //   history.push({
    //     pathname: '/view-branch',
    //    // search: '?query=abc',
    //     state: { branchName:br }
    // });
    //   localStorage.setItem('deptTypeName', br);
    //   let departmentName = localStorage.getItem('deptTypeName');

    //   let bData = {
    //     code:"b",
    //     deptTypeName:departmentName,
    //     departmentName:"Chief of Air Staff"
    //      };

    // dispatch(viewEditBranchAsyn(bData)).then((res) => {
    //   //form.resetFields()
    //   // resetBranch();
    //    dispatch(clearBrResponseState());
    // });
  }

  useEffect(() => {

    if (isError) {
      dispatch(clearState());
      setLoading(false);
      setToast(true);
      toast.error(errorMessage.toUpperCase());

    }
    if (isSuccess) {
      dispatch(clearState());
      let br = { name: branch.name, referenceNumber: branch.referenceNumber, description: branch.description ? branch.description[0] : '' };
      setPersonalInfo(br);
      let brState = { name: branch.name, referenceNumber: branch.referenceNumber, description: branch.description ? branch.description[0] : '', bd_directorates: branch.bd_directorates ? branch.bd_directorates : [] };
      setdBranch(brState);
      let brDir = branch.bd_directorates ? branch.bd_directorates : [];
      setbDirectorate(brDir);
      if (branch.referenceNumber) {
        let dref = [];
        branch.referenceNumber.forEach(val => {
          dref.push({ referenceNumber: val })
          //console.log(val)
        });
        form.setFieldsValue({
          arr_referenceNumber: dref,
          templateData: branch && branch.branch_templateDetail && branch.branch_templateDetail.processName ? branch.branch_templateDetail.processName : 'None',
        });
      }
      // setTimeout(() => {
      //   setLoading(false);
      //   setToast(true);
      //   toast.success(errorMessage.toUpperCase());
      //   history.push('/departments');
      // }, 1000);


    }

    if (isResponse) {
      setLoading(false);
      dispatch(clearResponseState());
    }

    if (isBrResponse) {
      setLoading(false);
      dispatch(clearBrResponseState());
      //setBrStorage(brName);
    }

  }, [isError, isSuccess, isResponse, isBrResponse, brName, setLoading, setToast, setBrStorage]);



  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }



  const onFinish = values => {
    // console.log(values)
    let referenceNumber = values.arr_referenceNumber.map(function ({ referenceNumber }) {
      return referenceNumber;
    });

    let bdDir = [];
    if (values.bd_directorates) {
      let bdDirdata = values.bd_directorates.map((d, di) => {
        let bd_referenceNumber = d.arr_bd_referenceNumber.map(function ({ bd_referenceNumber }) {
          return bd_referenceNumber;
        });
        let bdObject = { bd_name: d.bd_name, bd_description: d.bd_description, bd_referenceNumber: bd_referenceNumber };
        bdDir.push(bdObject);
      });
    }
    let formData = [];
    let formObj = { "name": values.name, "referenceNumber": referenceNumber ? referenceNumber : [], "description": values.description ? values.description : '', "b_directorate": values.b_directorate ? true : false, "bd_directorates": values.b_directorate ? bdDir : [] };
    formData.push(formObj);
    let data = {
      "departmentName": "Chief of Air Staff",
      "code": "b",
      "data": formData
    };

    setLoading(true);
    dispatch(viewEditBranchAsyn(data));

  }

  const onFinishFailed = (errorInfo) => {

    // console.log('Failed:', errorInfo);
  };

  const handleFinish = useCallback(values => {
    //console.log('Submit: ', values)
    setPending(true)
    setTimeout(() => {
      let referenceNumber = values.arr_referenceNumber.map(function ({ referenceNumber }) {
        return referenceNumber;
      });
      let data = {
        departmentName: "Chief of Air Staff",
        code: "b",
        deptTypeName: branchname,
        change: {
          name: values.name,
          referenceNumber: referenceNumber,
          description: values.description
        }
      }


      dispatch(updateBranchAsyn(data)).then((res) => {

        if (res.code == 200) {
          const state = { ...history.location.state };
          delete state.branchName;
          history.replace({ ...history.location, state });
          localStorage.removeItem("deptTypeName");
          localStorage.setItem('deptTypeName', values.name);
          setPending(false)
          let br = { name: values.name, referenceNumber: referenceNumber, description: values.description ? values.description : '' };
          setPersonalInfo(br);
          //setPersonalInfo(values)
          form.resetFields()
          resetBranch(values.name);
          // if(referenceNumber){
          //   let dref = [];
          //   referenceNumber.forEach(val => {
          //     dref.push({referenceNumber:val})
          //     //console.log(val)
          //    });
          //    form.setFieldsValue({
          //     arr_referenceNumber: dref
          //   });
          // }
          setViewMode(true)
          Modal.success({
            title: 'Success',
            content: res.message,
          })
        }
        else {
          setPending(false)
          Modal.error({
            title: 'Error',
            content: res.message,
          })
        }



      });

    }, 1500)
  });


  const handleFinishDr = useCallback(values => {
    //console.log('Submit: ', values)
    setPending(true)
    setTimeout(() => {
      let referenceNumber = values.arr_bd_referenceNumber.map(function ({ bd_referenceNumber }) {
        return bd_referenceNumber;
      });
      let bdDescription = Array.isArray(values.bd_description) ? values.bd_description[0] : values.bd_description;
      let data = {
        departmentName: "Chief of Air Staff",
        code: "bd",
        parentBranch: branchname,
        deptTypeName: values.directorate_name,
        change: {
          name: values.bd_name,
          referenceNumber: referenceNumber,
          description: bdDescription
        }
      }


      dispatch(updateBranchAsyn(data)).then((res) => {

        if (res.code == 200) {
          setPending(false)
          // formDr.resetFields()form.resetFields()
          // resetDr(branchname)
          formRef.current.resetFields();
          resetDr(branchname)
          // console.log('formRef')
          // console.log(formRef)
          setViewModeDr(true)
          Modal.success({
            title: 'Success',
            content: res.message,
          })
        }
        else {
          setPending(false)
          Modal.error({
            title: 'Error',
            content: res.message,
          })
        }



      });

    }, 1500)
  });


  const resetBranch = (brn) => {
    form.resetFields();
    let bData = {
      code: "b",
      deptTypeName: branchname,
      departmentName: "Chief of Air Staff"
    };

    dispatch(viewEditBranchAsyn(bData)).then((res) => {
      form.resetFields();
    });

  }

  const resetDr = (brn) => {
    let bData = {
      code: "b",
      deptTypeName: branchname,
      departmentName: "Chief of Air Staff"
    };

    dispatch(viewEditBranchAsyn(bData));
    setTimeout(() => {
      // console.log('directorate updated...')
      //   let bData = {
      //     code:"b",
      //     deptTypeName:brn,
      //     departmentName:"Chief of Air Staff"
      //      };

      // dispatch(viewEditBranchAsyn(bData)).then((res) => {
      //   //dispatch(clearState());

      //    let brDir = branch.bd_directorates?branch.bd_directorates:[];
      //    setbDirectorate(brDir);

      //  });


    }, 1000);

    //   let bData = {
    //     code:"b",
    //     deptTypeName:brn,
    //     departmentName:"Chief of Air Staff"
    //      };

    // dispatch(viewEditBranchAsyn(bData)).then((res) => {
    //   // dispatch(clearState());

    //   // let brDir = branch.bd_directorates?branch.bd_directorates:[];
    //   // setbDirectorate(brDir);

    //  });
  }

  const saveBranchName = (v) => {
    // console.log(v)
    if (form) {
      form
        .validateFields()
        .then(() => {
          setLoading(true);
          let obj = {
            "departmentName": "Chief of Air Staff",
            "code": "b",
            "deptTypeName": branchname,
            "change": {
              "name": v
            }
          }
          dispatch(updateBrOnlyAsyn(obj)).then((res) => {
            setLoading(false);
            localStorage.setItem('deptTypeName', v);
            history.push({
              pathname: '/view-branch',
              // search: '?query=abc',
              state: { branchName: v }
            });
            //dispatch(responseBrState(v));
          });
        });

    }
  }

  const saveBranch = (v, i) => {
    let brName = form.getFieldValue('name');
    let ref = form.getFieldValue('referenceNumber');
    let refIndexVal = ref[i];
    if (form) {
      form
        .validateFields()
        .then(() => {
          // console.log(JSON.stringify(refIndexVal))
          if (refIndexVal && refIndexVal._id) {
            setLoading(true);
            let obj = {
              "_id": refIndexVal._id,
              "code": "b",
              "deptTypeName": brName,
              "change": {
                "description": refIndexVal.description ? refIndexVal.description : '',
                "ref": refIndexVal.ref ? refIndexVal.ref : ''
              }
            }
            dispatch(editBrAsyn(obj)).then((res) => {
              dispatch(responseState());
            });
            // console.log(refIndexVal)
          }
          else {
            setLoading(true);
            let obj = {
              "code": "b",
              "deptTypeName": brName,
              "change": {
                "description": refIndexVal.description ? refIndexVal.description : '',
                "ref": refIndexVal.ref ? refIndexVal.ref : ''
              }
            }
            dispatch(editBrAsyn(obj)).then((res) => {
              dispatch(responseState());
            });
            //console.log(refIndexVal)
          }

        })
        .catch((errors) => {
          // Errors in the fields
        });
    }
    // if(v[i]){
    //   //console.log(JSON.stringify(v[i]))
    //   console.log(JSON.stringify(refIndexVal))
    //   console.log(' i='+i)
    // }
    // else{
    //   if(refIndexVal)console.log(JSON.stringify(refIndexVal.ref))
    //   if(form
    //     .validateFields() && refIndexVal && refIndexVal.ref!=''){
    //     form
    //       .validateFields()
    //       .then(() => {
    //         console.log(JSON.stringify(refIndexVal))
    //           console.log(i)
    //       })
    //       .catch((errors) => {
    //         // Errors in the fields
    //       });
    //   }

    // }

  }

  const delBranch = (value, name) => {
    let brName = form.getFieldValue('name');
    setLoading(true);
    let obj = {
      "code": "b",
      "deptTypeName": brName,
      '_id': value[name]._id, 'delete': true
    }
    dispatch(editBrAsyn(obj)).then((res) => {
      dispatch(responseState());
    });

  }

  const typoExpand = (e, i) => {
    // console.log(e)
    setExpand(true);
    let count = !expand ? counter + 0 : counter + 1;
    setCounter(count);
    setExpandable(false);
    // state['expand_'+i]?!state['expand_'+i]
    let name = 'expand_' + i;
    setState(prev => ({
      ...prev,
      [name]: !state['expand_' + i]
    }));
  };

  const typoClose = (i) => {
    setExpand(false);
    let count = !expand ? counter + 0 : counter + 1;
    setCounter(count);
    setExpandable(true);
    let name = 'expand_' + i;
    setState(prev => ({
      ...prev,
      [name]: !state['expand_' + i]
    }));
  };

  const getMeta = () => {
    const meta = {
      //columns: 2,
      disabled: pending,
      initialValues: personalInfo,
      fields: [
        {
          key: 'name',
          widget: ({ value, onChange }) => {
            return (
              <>

                <Form.Item style={{ marginBottom: 0, marginTop: 0 }}>
                  <p className={'refno-heading'}>Branch</p>
                  <Row>
                    <Col flex="100%" className={'refHeadingTbl'}>Name</Col>
                  </Row>
                  <Form.Item
                    name={'name'}
                    //style={{width:'80%',paddingTop:20,paddingBottom:20}}
                    style={{ display: 'inline-block', width: '89%', paddingTop: 20 }}
                    rules={[{ required: true, message: 'Name is required' }]}
                    requiredMark={'optional'}
                  //label={<p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,marginTop:15}}>Description</p>}
                  >
                    <Input className="formInput" placeholder="" />
                  </Form.Item>
                  <Form.Item
                    style={{ display: 'inline-block', width: '10%', paddingTop: 30 }}
                  >
                    <Button style={{ fontSize: 18, fontWeight: 500, marginTop: 0 }} onClick={() => saveBranchName(value)} type="link"><AiOutlineSave /></Button>
                  </Form.Item>

                </Form.Item>
              </>
            )
          },
          renderView: (v) => {
            return (
              <h1 className="branchh1">{capitalizeFirstLetter(v)}</h1>
            )
          },
        },
        {
          key: 'referenceNumber',
          //label: 'Reference No.',
          renderView: (v) => {
            return (
              <>
                {/* <p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,marginTop:10,wordBreak:'break-all'}}>Reference No</p> */}
                <p className={'refno-heading'}>Reference No</p>
                <p
                  style={{
                    fontStyle: "normal",
                    fontWeight: "normal",
                    fontSize: 18,
                    color: "#000000",
                    marginBottom: 0,
                    wordBreak: 'break-all'
                  }}
                >
                  {/* {v.join(',')}  */}
                  <Row>
                    <Col span={8} className={'refHeadingTbl'}>Reference No</Col>
                    <Col span={16} className={'refHeadingTbl'}>Description</Col>
                  </Row>
                  {v && v.length > 0
                    ? <>
                      {
                        v.map((val, i) => {
                          return (
                            <Row className={'paddingBtableTop'}>
                              <Col span={8}>{val.ref}</Col>
                              <Col span={16}>
                                <div key={counter + 1}>

                                  <Paragraph
                                    ellipsis={{
                                      rows: 2,
                                      expandable: state && state['expand_' + i] ? true : expandable,
                                      symbol: 'More',
                                      onExpand: (e) => typoExpand(e, i)
                                    }}
                                  >
                                    {val.description}
                                  </Paragraph>
                                </div>
                                {state['expand_' + i] && <a onClick={() => typoClose(i)}>Close</a>}
                                {/* {expand && <a onClick={() => typoClose(i)}>Close</a>} */}
                              </Col>
                            </Row>
                          )
                        })

                      }
                    </>
                    : <Row className={'paddingBtableTop'}>
                      <Col span={24}>No records found</Col>
                    </Row>
                  }

                </p>
              </>
            )
          },
          widget: ({ value, onChange }) => {
            return (
              <>
                <p className={'refno-heading'}>Reference No</p>
                <Row>
                  <Col flex="30%" className={'refHeadingTbl'}>Reference No*</Col>
                  <Col flex="60%" className={'refHeadingTbl'}>Description</Col>
                </Row>
                <Form.List name="referenceNumber" initialValue={[{ ref: '', description: '' }]} >
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map(({ key, name, fieldKey, ...restField }) => (
                        <Form.Item style={{ marginBottom: 0 }}>

                          <Form.Item
                            {...restField}
                            name={[name, 'ref']}
                            style={{ display: 'inline-block', width: 'calc(30% - 8px)', marginRight: 5 }}
                            // label={key==0 ?<Row style={{width:'100%'}}><Col span={18}><p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,marginTop:15}}>Reference No*</p></Col><Col style={{textAlign:'right'}} span={6}><Button style={{marginBottom:-2,marginTop:12,padding:0,fontSize:18,fontWeight:500}} onClick={() => add()} type="link">+ ADD</Button></Col></Row>: <Row style={{width:'100%',marginBottom:-25}}><Col span={18}><p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,marginTop:15}}>Reference No*</p></Col><Col style={{textAlign:'right'}} span={6}><Button style={{marginBottom:-2,marginTop:12,padding:0,fontSize:18,fontWeight:500}} onClick={() => remove(name)} type="link"><MinusCircleOutlined  /></Button></Col></Row>}
                            // label={<p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,marginTop:15}}>Reference No*</p>}
                            label={<p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0, marginTop: 15 }}></p>}
                            fieldKey={[fieldKey, 'ref']}
                            rules={[{ required: true, message: 'Reference No is required' }]}
                            requiredMark={'optional'}
                          >
                            <Input className="formInput" placeholder="" />
                          </Form.Item>

                          <Form.Item
                            //name={'description'}
                            {...restField}
                            name={[name, 'description']}
                            fieldKey={[fieldKey, 'description']}
                            style={{ display: 'inline-block', width: 'calc(60% - 8px)', marginTop: -9 }}

                            // label={key==0 ?<Row style={{width:'100%'}}><Col span={18}><p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,marginTop:15}}>Description</p></Col><Col style={{textAlign:'right'}} span={6}><Button style={{marginBottom:0,marginTop:3.5,padding:0,fontSize:18,fontWeight:500}} onClick={() => add()} type="link">+ ADD</Button></Col></Row>: <Row style={{width:'100%',marginBottom:-25}}><Col span={18}><p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,marginTop:15}}>Description</p></Col><Col style={{textAlign:'right'}} span={6}><Button style={{marginBottom:-2,marginTop:12,padding:0,fontSize:18,fontWeight:500}} onClick={() => remove(name)} type="link"><MinusCircleOutlined  /></Button></Col></Row>}
                            //label={key==0 ?<Row style={{width:'100%'}}><Col span={18}><p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,marginTop:0}}> </p></Col><Col style={{textAlign:'right'}} span={6}><Button style={{marginBottom:0,marginTop:3.5,padding:0,fontSize:18,fontWeight:500}} onClick={() => add()} type="link">+ ADD</Button></Col></Row>: <Row style={{width:'100%',marginBottom:-25}}><Col span={18}><p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,marginTop:0}}> </p></Col><Col style={{textAlign:'right'}} span={6}><Button style={{marginBottom:-2,marginTop:12,padding:0,fontSize:18,fontWeight:500}} onClick={() => remove(name)} type="link"><MinusCircleOutlined  /></Button></Col></Row>}
                            // label={key==0 ?<Row style={{width:'100%'}}><Col span={18}><p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,marginTop:0}}> </p></Col><Col style={{textAlign:'right'}} span={6}><Button style={{marginBottom:0,marginTop:0,padding:0,fontSize:18,fontWeight:500}} onClick={() => add()} type="link">+ ADD</Button></Col></Row>: <Row style={{width:'100%',marginBottom:0}}><Col span={18}><p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,marginTop:0}}> </p></Col><Col style={{textAlign:'right'}} span={6}><Button style={{marginBottom:0,marginTop:0,padding:0,fontSize:18,fontWeight:500}} onClick={() => remove(name)} type="link"><MinusCircleOutlined  /></Button></Col></Row>}
                            // label={<p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,marginTop:0}}>Description</p>}
                            // label={<Row style={{width:'100%'}}><Col span={24}><Button onClick={() => add()} type="link">+ ADD</Button></Col></Row>}
                            // label={key==0 ?<Row style={{width:'100%'}}><Col style={{textAlign:'right'}} span={24}><Button style={{fontSize:18,fontWeight:500}} onClick={() => add()} type="link">+ ADD</Button></Col></Row>: <Row style={{width:'100%',marginBottom:-25}}><Col style={{textAlign:'right'}} span={24}><Button style={{fontSize:18,fontWeight:500}} onClick={() => remove(name)} type="link"><MinusCircleOutlined  /></Button></Col></Row>}
                            label={key == 0 ? <Row style={{ width: '100%' }}><Col style={{ textAlign: 'right' }} span={24}><Button style={{ fontSize: 18, fontWeight: 500, marginRight: -15 }} onClick={() => add()} type="link">+ ADD</Button></Col></Row> : <Row style={{ width: '100%', marginBottom: 15 }}></Row>}
                          >

                            <TextArea style={{ lineHeight: 1.2 }} rows={0} className="formInput" placeholder="" />
                          </Form.Item>
                          <Form.Item
                            style={{ display: 'inline-block', width: 'calc(10% - 8px)', marginTop: -9 }}
                          >
                            {key == 0
                              ? <Button style={{ fontSize: 18, fontWeight: 500, marginTop: 45 }} onClick={() => saveBranch(value, name)} type="link"><AiOutlineSave /></Button>
                              : <>
                                <Button style={{ fontSize: 18, fontWeight: 500, marginTop: 32 }} type="link">
                                  <Popconfirm onConfirm={() => { remove(name); if (value[name]) { delBranch(value, name) } }} title="Are you sure？" icon={<QuestionCircleOutlined style={{ color: 'red' }} />}>
                                    <a href="#"><RiDeleteBinLine /></a>
                                  </Popconfirm>
                                </Button>

                                {/* <Button style={{fontSize:18,fontWeight:500,marginTop:32}} onClick={() => {remove(name);if(value[name]){delBranch(value,name)}}} type="link"><RiDeleteBinLine  /></Button> */}
                                <Button style={{ fontSize: 18, fontWeight: 500, marginTop: 0 }} onClick={() => saveBranch(value, name)} type="link"><AiOutlineSave /></Button>
                              </>
                            }
                            {/* {key!==0 && 
                  <Button style={{fontSize:18,fontWeight:500,marginTop:32}} onClick={() => remove(name)} type="link"><RiDeleteBinLine  /></Button>
                 }
               <Button style={{fontSize:18,fontWeight:500,marginTop:0}} onClick={() => remove(name)} type="link"><AiOutlineSave  /></Button> */}
                            {/* <Button htmlType="submit" type="primary" disabled={pending}>
              {pending ? 'Updating...' : 'Update'}
            </Button> */}
                          </Form.Item>

                        </Form.Item>
                      ))}
                    </>
                  )}
                </Form.List>
              </>
              //   <Form.List name="arr_referenceNumber" initialValue={[{referenceNumber:''}]} >
              //   {(fields, { add, remove }) => (
              //     <>
              //       {fields.map(({ key, name, fieldKey, ...restField }) => (
              //         <Form.Item
              //         {...restField}
              //         name={[name,'referenceNumber']}

              //           label={key==0 ?<Row style={{width:'100%'}}><Col span={18}><p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,marginTop:15}}>Reference No*</p></Col><Col style={{textAlign:'right'}} span={6}><Button style={{marginBottom:-2,marginTop:12,padding:0,fontSize:18,fontWeight:500}} onClick={() => add()} type="link">+ ADD</Button></Col></Row>: <Row style={{width:'100%',marginBottom:-25}}><Col span={18}><p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,marginTop:15}}>Reference No*</p></Col><Col style={{textAlign:'right'}} span={6}><Button style={{marginBottom:-2,marginTop:12,padding:0,fontSize:18,fontWeight:500}} onClick={() => remove(name)} type="link"><MinusCircleOutlined  /></Button></Col></Row>}
              //           fieldKey={[fieldKey, 'referenceNumber']}
              //           rules={[{ required: true, message: 'Reference No is required' }]}
              //           requiredMark={'optional'}
              //         >
              //           <Input className="formInput" placeholder="" />
              //         </Form.Item>
              //       ))}
              //     </>
              //   )}
              //  </Form.List>
            )
          },
          // widgetProps: { id: personalInfo },
          // render: () => {
          //   <h1>helo</h1>
          // }
        },
        // { 
        //   key: 'description', 
        //   //label: 'Description',
        //   widget: () => {
        //     return (
        //   <Form.Item
        //   name={'description'}
        //   label={<p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,marginTop:15}}>Description</p>}
        //   >
        //   <TextArea rows={4} className="formInput" placeholder="" />
        //   </Form.Item>
        //     )},
        //   renderView: (v) => {
        //     return (
        //       <>
        //        <p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,marginTop:10,wordBreak:'break-all'}}>Description</p>
        //       <p
        //       style={{
        //         fontStyle: "normal",
        //         fontWeight: "normal",
        //         fontSize: 18,
        //         color: "#000000",
        //         marginBottom: 0,
        //         wordBreak:'break-all'
        //       }}
        //     >{v}</p>
        //     </>
        //     )
        //   },
        //  },
      ],
    }
    return meta
  }


  const saveDR = (v, i, drInfo) => {
    // let drName = formDr.getFieldValue('bd_name');
    // let ref = formDr.getFieldValue('bd_referenceNumber');
    // let refIndexVal = ref[i];
    let refIndexVal = v[i];
    if (formDr) {
      formDr
        .validateFields()
        .then(() => {
          if (refIndexVal && refIndexVal._id) {
            setLoading(true);
            let obj = {
              "_id": refIndexVal._id,
              "code": "bd",
              "deptTypeName": drInfo.bd_name,
              "parentBranch": drInfo.parentBranch,
              "change": {
                "description": refIndexVal.description ? refIndexVal.description : '',
                "ref": refIndexVal.ref ? refIndexVal.ref : ''
              }
            }
            dispatch(editBrAsyn(obj)).then((res) => {
              dispatch(responseState());
            });
            //console.log(refIndexVal)
          }
          else {
            setLoading(true);
            let obj = {
              "code": "bd",
              "deptTypeName": drInfo.bd_name,
              "parentBranch": drInfo.parentBranch,
              "change": {
                "description": refIndexVal.description ? refIndexVal.description : '',
                "ref": refIndexVal.ref ? refIndexVal.ref : ''
              }
            }
            dispatch(editBrAsyn(obj)).then((res) => {
              dispatch(responseState());
            });
            //console.log(refIndexVal)
          }

        })
        .catch((errors) => {
          // Errors in the fields
        });
    }

  }

  const delDR = (value, name, drInfo) => {
    // console.log(drInfo)
    // let brName = formDr.getFieldValue('bd_name');
    setLoading(true);
    let obj = {
      "code": "bd",
      "_id": value[name]._id,
      "parentBranch": drInfo.parentBranch,
      "deptTypeName": drInfo.bd_name,
      "delete": true
    }
    dispatch(editBrAsyn(obj)).then((res) => {
      dispatch(responseState());
    });

  }

  const saveDrName = (pinfo, v) => {
    // console.log(v)
    // console.log(pinfo)
    if (formDr) {
      formDr
        .validateFields()
        .then(() => {
          setLoading(true);
          let obj = {
            "departmentName": "Chief of Air Staff",
            "code": "bd",
            "deptTypeName": pinfo.bd_name,
            "parentBranch": pinfo.parentBranch,
            "change": {
              "name": v
            }
          }
          dispatch(updateBrOnlyAsyn(obj)).then((res) => {
            setLoading(false);
            history.push({
              pathname: '/view-branch',
              // search: '?query=abc',
              state: { branchName: pinfo.parentBranch }
            });
            //dispatch(responseBrState(v));
          });
        });

    }
  }


  const typoDrExpand = (e, i) => {
    // console.log(e)
    setdrExpand(true);
    let count = !drexpand ? drcounter + 0 : drcounter + 1;
    setdrCounter(count);
    setdrExpandable(false);
    // state['expand_'+i]?!state['expand_'+i]
    let name = 'expanddr_' + i;
    setState(prev => ({
      ...prev,
      [name]: !state['expanddr_' + i]
    }));
  };

  const typoDrClose = (i) => {
    setdrExpand(false);
    let count = !drexpand ? drcounter + 0 : drcounter + 1;
    setdrCounter(count);
    setdrExpandable(true);
    let name = 'expanddr_' + i;
    setState(prev => ({
      ...prev,
      [name]: !state['expanddr_' + i]
    }));
  };

  const getMetaDr = (drInfo) => {
    const meta = {
      //columns: 2,
      disabled: pending,
      initialValues: drInfo,
      fields: [
        {
          key: 'bd_name',
          viewMode: false,
          label: '',
          widget: ({ value, onChange }) => {
            return (
              <>

                <Form.Item style={{ marginBottom: 0, marginTop: 0 }}>
                  <p className={'refno-heading'}>Directorate</p>
                  <Row>
                    <Col flex="100%" className={'refHeadingTbl'}>Name</Col>
                  </Row>
                  <Form.Item
                    name={'bd_name'}
                    //style={{width:'80%',paddingTop:20,paddingBottom:20}}
                    style={{ display: 'inline-block', width: '89%', paddingTop: 20 }}
                    rules={[{ required: true, message: 'Name is required' }]}
                    requiredMark={'optional'}
                  //label={<p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,marginTop:15}}>Description</p>}
                  >
                    <Input className="formInput" placeholder="" />
                  </Form.Item>
                  <Form.Item
                    style={{ display: 'inline-block', width: '10%', paddingTop: 30 }}
                  >
                    <Button style={{ fontSize: 18, fontWeight: 500, marginTop: 0 }} onClick={(e) => saveDrName(drInfo, value)} type="link"><AiOutlineSave /></Button>
                  </Form.Item>

                </Form.Item>
              </>
              //   <Form.Item
              //   name={'bd_name'}
              //   //label={<p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,marginTop:15}}>Description</p>}
              //   >
              //  <Input className="formInput" placeholder="" />
              //   </Form.Item>
            )
          },
          renderView: (v) => {
            return (
              <span></span>
            )
          },
        },
        {
          key: 'bd_referenceNumber',
          //label: 'Reference No.',
          renderView: (v) => {
            return (
              <>
                <p className={'refno-heading'}>Reference No &nbsp; {genExtra()}</p>
                <p
                  style={{
                    fontStyle: "normal",
                    fontWeight: "normal",
                    fontSize: 18,
                    color: "#000000",
                    marginBottom: 0,
                    wordBreak: 'break-all'
                  }}
                >
                  {/* {v.join(',')}  */}
                  <Row>
                    <Col span={8} className={'refHeadingTbl'}>Reference No</Col>
                    <Col span={16} className={'refHeadingTbl'}>Description</Col>
                  </Row>
                  {v && v.length > 0
                    ? <>
                      {
                        v.map((val, i) => {
                          return (
                            <Row className={'paddingBtableTop'}>
                              <Col span={8}>{val.ref}</Col>
                              <Col span={16}>
                                <div key={drcounter + 1}>

                                  <Paragraph
                                    ellipsis={{
                                      rows: 2,
                                      expandable: state && state['expanddr_' + i] ? true : drexpandable,
                                      symbol: 'More',
                                      onExpand: (e) => typoDrExpand(e, i)
                                    }}
                                  >
                                    {val.description}
                                  </Paragraph>
                                </div>
                                {state['expanddr_' + i] && <a onClick={() => typoDrClose(i)}>Close</a>}
                                {/* {expand && <a onClick={() => typoClose(i)}>Close</a>} */}
                              </Col>
                            </Row>
                          )
                        })

                      }
                    </>
                    : <Row className={'paddingBtableTop'}>
                      <Col span={24}>No records found</Col>
                    </Row>
                  }

                </p>
                {/* <p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,marginTop:-50,wordBreak:'break-all'}}>Reference No</p>
              <p
              style={{
                fontStyle: "normal",
                fontWeight: "normal",
                fontSize: 18,
                color: "#000000",
                marginBottom: 0,
                wordBreak:'break-all'
              }}
            >{v.join(',')}</p> */}
              </>
            )
          },
          widget: ({ value, onChange }) => {
            let bdrref = [];
            if (drInfo.bd_referenceNumber) {
              drInfo.bd_referenceNumber.forEach(v => {
                bdrref.push({ bd_referenceNumber: v })
              });
            }
            return (
              <>
                <p className={'refno-heading'}>Reference No</p>
                <Row>
                  <Col flex="30%" className={'refHeadingTbl'}>Reference No*</Col>
                  <Col flex="60%" className={'refHeadingTbl'}>Description</Col>
                </Row>
                <Form.List name="bd_referenceNumber" initialValue={[{ ref: '', description: '' }]} >
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map(({ key, name, fieldKey, ...restField }) => (
                        <Form.Item style={{ marginBottom: 0 }}>

                          <Form.Item
                            {...restField}
                            name={[name, 'ref']}
                            style={{ display: 'inline-block', width: 'calc(30% - 8px)', marginRight: 5 }}
                            // label={key==0 ?<Row style={{width:'100%'}}><Col span={18}><p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,marginTop:15}}>Reference No*</p></Col><Col style={{textAlign:'right'}} span={6}><Button style={{marginBottom:-2,marginTop:12,padding:0,fontSize:18,fontWeight:500}} onClick={() => add()} type="link">+ ADD</Button></Col></Row>: <Row style={{width:'100%',marginBottom:-25}}><Col span={18}><p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,marginTop:15}}>Reference No*</p></Col><Col style={{textAlign:'right'}} span={6}><Button style={{marginBottom:-2,marginTop:12,padding:0,fontSize:18,fontWeight:500}} onClick={() => remove(name)} type="link"><MinusCircleOutlined  /></Button></Col></Row>}
                            // label={<p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,marginTop:15}}>Reference No*</p>}
                            label={<p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0, marginTop: 15 }}></p>}
                            fieldKey={[fieldKey, 'ref']}
                            rules={[{ required: true, message: 'Reference No is required' }]}
                            requiredMark={'optional'}
                          >
                            <Input className="formInput" placeholder="" />
                          </Form.Item>

                          <Form.Item
                            {...restField}
                            name={[name, 'description']}
                            fieldKey={[fieldKey, 'description']}
                            style={{ display: 'inline-block', width: 'calc(60% - 8px)', marginTop: -9 }}
                            label={key == 0 ? <Row style={{ width: '100%' }}><Col style={{ textAlign: 'right' }} span={24}><Button style={{ fontSize: 18, fontWeight: 500, marginRight: -15 }} onClick={() => add()} type="link">+ ADD</Button></Col></Row> : <Row style={{ width: '100%', marginBottom: 15 }}></Row>}
                          >

                            <TextArea style={{ lineHeight: 1.2 }} rows={0} className="formInput" placeholder="" />
                          </Form.Item>
                          <Form.Item
                            style={{ display: 'inline-block', width: 'calc(10% - 8px)', marginTop: -9 }}
                          >
                            {key == 0
                              ? <Button style={{ fontSize: 18, fontWeight: 500, marginTop: 45 }} onClick={() => saveDR(value, name, drInfo)} type="link"><AiOutlineSave /></Button>
                              : <>
                                <Button style={{ fontSize: 18, fontWeight: 500, marginTop: 32 }} type="link">
                                  <Popconfirm onConfirm={() => { remove(name); if (value[name]) { delDR(value, name, drInfo) } }} title="Are you sure？" icon={<QuestionCircleOutlined style={{ color: 'red' }} />}>
                                    <a href="#"><RiDeleteBinLine /></a>
                                  </Popconfirm>
                                </Button>
                                <Button style={{ fontSize: 18, fontWeight: 500, marginTop: 0 }} onClick={() => saveDR(value, name, drInfo)} type="link"><AiOutlineSave /></Button>
                              </>
                            }
                          </Form.Item>

                        </Form.Item>
                      ))}
                    </>
                  )}
                </Form.List>
              </>
              //   <Form.List name="arr_bd_referenceNumber" initialValue={bdrref} >
              //   {(fields, { add, remove }) => (
              //     <>
              //       {fields.map(({ key, name, fieldKey, ...restField }) => (
              //         <Form.Item
              //         {...restField}
              //         name={[name,'bd_referenceNumber']}

              //           label={key==0 ?<Row style={{width:'100%'}}><Col span={18}><p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,marginTop:15}}>Reference No*</p></Col><Col style={{textAlign:'right'}} span={6}><Button style={{marginBottom:-2,marginTop:12,padding:0,fontSize:18,fontWeight:500}} onClick={() => add()} type="link">+ ADD</Button></Col></Row>: <Row style={{width:'100%',marginBottom:-25}}><Col span={18}><p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,marginTop:15}}>Reference No*</p></Col><Col style={{textAlign:'right'}} span={6}><Button style={{marginBottom:-2,marginTop:12,padding:0,fontSize:18,fontWeight:500}} onClick={() => remove(name)} type="link"><MinusCircleOutlined  /></Button></Col></Row>}
              //           fieldKey={[fieldKey, 'referenceNumber']}
              //           rules={[{ required: true, message: 'Reference No is required' }]}
              //           requiredMark={'optional'}
              //         >
              //           <Input className="formInput" placeholder="" />
              //         </Form.Item>
              //       ))}
              //     </>
              //   )}
              //  </Form.List>
            )
          },
          // render: () => {
          //   <h1>helo</h1>
          // }
        },
        // { 
        //   key: 'bd_description', 
        //   //label: 'Description',
        //   widget: () => {
        //     return (
        //   <Form.Item
        //   name={'bd_description'}
        //   label={<p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,marginTop:15}}>Description</p>}
        //   >
        //   <TextArea rows={4} className="formInput" placeholder="" />
        //   </Form.Item>
        //     )},
        //   renderView: (v) => {
        //     return (
        //       <>
        //        <p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,marginTop:10,wordBreak:'break-all'}}>Description</p>
        //       <p
        //       style={{
        //         fontStyle: "normal",
        //         fontWeight: "normal",
        //         fontSize: 18,
        //         color: "#000000",
        //         marginBottom: 0,
        //         wordBreak:'break-all'
        //       }}
        //     >{v}</p>
        //     </>
        //     )
        //   },
        //  },
      ],
    }
    return meta
  }

  function callback(key) {
    // console.log(key);
    setopenPanel(key);
    formDr.resetFields()
  }

  const text = `
  A dog is a type of domesticated animal.
  Known for its loyalty and faithfulness,
  it can be found as a welcome guest in many households across the world.
`;

  // const genExtra = () => (
  //   <>
  //   <Can I="manageB" a="edit"> 
  //   {viewModeDr
  //    ?<EditOutlined
  //    onClick={event => {
  //      formRef.current.resetFields();
  //      resetDr(branchname);
  //      setViewModeDr(false);
  //      // If you don't want click extra trigger collapse, you can prevent this:
  //      event.stopPropagation();
  //    }}
  //    />
  //    :<EyeOutlined
  //    onClick={event => {
  //      formRef.current.resetFields();
  //      resetDr(branchname);
  //      setViewModeDr(true);
  //      // If you don't want click extra trigger collapse, you can prevent this:
  //      event.stopPropagation();
  //    }}
  //    />

  //   }
  //    </Can>

  //   </>
  // );

  const genExtra = () => (
    <>
      <Can I="manageB" a="edit">
        {viewModeDr
          ? <EditOutlined
            onClick={event => {
              formRef.current.resetFields();
              resetDr(branchname);
              setViewModeDr(false);

              // If you don't want click extra trigger collapse, you can prevent this:
              event.stopPropagation();
            }}
          />
          : <EyeOutlined
            onClick={event => {
              formRef.current.resetFields();
              resetDr(branchname);
              setViewModeDr(true);
              // If you don't want click extra trigger collapse, you can prevent this:
              event.stopPropagation();
            }}
          />

        }
      </Can>

    </>
  );

  const getReferenceNos = () => {
    let children = [];
    let seenStampList = seenStampData ? seenStampData : [];
    // console.log('seenStampList')
    // console.log(seenStampList)
    if (seenStampList && seenStampList.length > 0) {
      for (let i = 0; i < seenStampList.length; i++) {
        children.push(<Option key={i.toString() + i} value={seenStampList[i].uuid}>{seenStampList[i].processName}</Option>);
      }
    }
    return children;
  }


  const panelHeader = (v) => (
    // <>{capitalizeFirstLetter(v.bd_name)} <Switch defaultChecked style={{marginLeft:20}} /></>

    <div class="view-branch-directorate-clps-content">
      <span onClick={event => { event.stopPropagation() }}><span>{capitalizeFirstLetter(v.bd_name)}</span><Can I="manageB" a="enable/disable"><span>{v.active ? <Switch onChange={(e) => updateStatusDR(e, v.bd_name)} defaultChecked style={{ marginLeft: 20 }} /> : <Switch onChange={(e) => updateStatusDR(e, v.bd_name)} style={{ marginLeft: 20 }} />}</span> </Can></span>
      <Select defaultValue={v.templateDetail && v.templateDetail.processName ? v.templateDetail.processName : 'None'} onChange={(event, chnagedata) => onTemplateListChange(event, v, chnagedata)} onClick={event => { event.stopPropagation() }} className='view-branch-directorate-clps-dropdown'>
        <Option value="None">None</Option>
        {getReferenceNos()}
      </Select>
    </div>

  );


  const onTemplateListChange = (event, rowData, chnageData) => {

    console.log("event =" + event + " rowData = " + JSON.stringify(rowData) + " chnageData =" + JSON.stringify(chnageData))

    let data = {
      "departmentName": "Chief of Air Staff",
      "code": "bd",
      "parentBranch": rowData.parentBranch,
      "deptTypeName": rowData.bd_name,
      "deleteTemplateUUID": chnageData.value === 'None' ? true : false,
      // "templateUUID": chnageData.value,
    }
    if (chnageData.value != 'None') data["templateUUID"] = chnageData.value
    dispatch(updateSeenStampForAdminAsyn(data));

  }

  const onlyBranchTemplateListChange = (event, changeData) => {
    let bData = {
      code: "b",
      deptTypeName: branchname,
      departmentName: "Chief of Air Staff",
      deleteTemplateUUID: changeData.value === 'None' ? true : false,
    };
    if (changeData.value != 'None') bData["templateUUID"] = changeData.value;
    dispatch(updateSeenStampForAdminAsyn(bData));
  }


  const updateStatusDR = (e, dr) => {
    let dData = {
      department: "Chief of Air Staff",
      code: "bd",
      parentBranch: branchname,
      deptTypeName: dr
    };

    dispatch(updateDrStatusAsyn(dData));
  }


  const handleDrSubmit = useCallback(values => {
    // console.log('Submit: ', values)
    let bdDir = [];
    if (values.bd_directorates_add) {
      let bdDirdata = values.bd_directorates_add.map((d, di) => {

        let referenceNumber = d.arr_bdreferenceNumber.map(function ({ referenceNumber, description }) {
          return { ref: referenceNumber, description: description };
        });

        let bdObject = { name: d.name, referenceNumber: referenceNumber };
        bdDir.push(bdObject);
        // console.log("des=> " + JSON.stringify(bdDir, null, '\t'));
      });
    }

    setPending(true)
    let Drdata = {
      departmentName: "Chief of Air Staff",
      code: "bd",
      parentBranch: branchname,
      data: bdDir
    }

    // console.log("Drdata=> " + JSON.stringify(Drdata, null, '\t'));

    dispatch(addDrAsyn(Drdata)).then((res) => {

      if (res.code == 201) {
        setPending(false)
        formDrRef.current.resetFields();
        formDrRef.current.setFieldsValue({
          bd_directorates_add: ''
        });
        Modal.success({
          title: 'Success',
          content: res.message,
          onOk() {
            let bData = {
              code: "b",
              deptTypeName: branchname,
              departmentName: "Chief of Air Staff"
            };

            dispatch(viewEditBranchAsyn(bData));
          }
        })
      }
      else {
        setPending(false)
        Modal.error({
          title: 'Error',
          content: res.message,
        })
      }
    });

  });

  return (
    <>
      <Container>
        <Spin indicator={antIcon} style={{ alignItems: 'center', justifyContent: 'center', justifyItems: 'center', textAlign: 'center', width: '100%', maxHeight: '100%', position: 'fixed', zIndex: 1111, left: 0, right: 0, top: '45%', bottom: 0 }} spinning={isLoading} />
        <Breadcrumb style={{ margin: '16px 0', paddingLeft: 50, marginBottom: 0 }} separator=">">
          <Breadcrumb.Item><Link to={'/departments'}>Departments</Link></Breadcrumb.Item>
          <Breadcrumb.Item>View Branch</Breadcrumb.Item>
        </Breadcrumb>
        <div className="site-layout-content" style={{ marginTop: 0, paddingTop: 0 }}>

          <div style={{ padding: 24, paddingTop: 16 }}>
            {/* <Spin indicator={antIcon} style={{textAlign:'center',width:'100%',position:'fixed',zIndex:1111,left:0,right:0,top:'45%',bottom:0}} spinning={isLoading} /> */}
            {isToast &&
              <Toaster
                toastOptions={{
                  className: '',
                  style: {
                    border: '1px solid #713200',
                    padding: '16px',
                    color: '#713200',
                    marginTop: 50
                  },
                }}
              >
                {(t) => (
                  <ToastBar toast={t}>
                    {({ icon, message }) => (
                      <>
                        {icon}
                        {message}
                        {t.type !== 'loading' && (
                          <button onClick={() => toast.dismiss(t.id)}>X</button>
                        )}
                      </>
                    )}
                  </ToastBar>
                )}
              </Toaster>
            }
            <div>
              <Row style={{ backgroundColor: "#ffffff", paddingTop: 35, paddingBottom: 20, borderLeft: '1px solid #dfe0eb', borderRight: '1px solid #dfe0eb', borderTop: '1px solid #dfe0eb', borderBottom: '2px solid #e8e8e8' }}>
                <Col span="3"></Col>
                <Col span="12" >
                  <h1 style={{ fontWeight: 'bold', fontStyle: 'normal', fontSize: 24 }}>Branch Details</h1>
                </Col>
                <Col span="9" style={{ paddingLeft: 25 }}>

                </Col>
              </Row>


              <Form
                form={form}
                layout="vertical"
                labelCol={{ span: 16 }}
                wrapperCol={{ span: 24 }}
                onFinish={handleFinish}
              >
                {/* <Row  style={{paddingTop:24,paddingBottom:80,borderLeft:'1px solid #dfe0eb',borderRight:'1px solid #dfe0eb',borderBottom:'1px solid #dfe0eb'}}> */}
                <Row style={{ backgroundColor: "#ffffff", paddingTop: 24, borderLeft: '1px solid #dfe0eb', borderRight: '1px solid #dfe0eb' }}>
                  <Col span="3"></Col>
                  <Col span="18"  >


                    <Form.Item name={'templateData'} className="independent-directorate-details-clps-from">
                      <Select onChange={(event, chnagedata) => onlyBranchTemplateListChange(event, chnagedata)} onClick={event => { event.stopPropagation() }} className='independent-directorate-details-clps-dropdown'>
                        <Option value="None">None</Option>
                        {getReferenceNos()}
                      </Select>
                    </Form.Item>

                    <Can I="manageB" a="edit">
                      {viewMode && (
                        <Button type="link" onClick={() => {
                          setViewMode(false)
                        }} style={{ fontWeight: 'normal', fontSize: 24, color: '#000', float: 'right' }}>
                          <EditOutlined /> &nbsp;Edit
                        </Button>
                      )}
                    </Can>

                    <FormBuilder form={form} getMeta={getMeta} viewMode={viewMode} />
                    {!viewMode && (
                      <Form.Item className="form-footer" wrapperCol={{ span: 24, offset: 0 }}>
                        <Button
                          type={'primary'}
                          onClick={() => {
                            //form.resetFields()
                            resetBranch(branchname)
                            setViewMode(true)
                          }}
                          style={{ marginLeft: '0px' }}
                        >
                          Cancel
                        </Button>
                      </Form.Item>
                    )}
                    {/* {!viewMode && (
          <Form.Item className="form-footer" wrapperCol={{ span: 24, offset: 0 }}>
            <Button htmlType="submit" type="primary" disabled={pending}>
              {pending ? 'Updating...' : 'Update'}
            </Button>
            <Button
              onClick={() => {
                //form.resetFields()
                resetBranch(branchname)
                setViewMode(true)
              }}
              style={{ marginLeft: '15px' }}
            >
              Cancel
            </Button>
          </Form.Item>
        )} */}

                    <Form.Item >
                      <hr style={{ borderTop: "1px solid #dfe1e6", marginTop: 30 }} />
                    </Form.Item>
                  </Col>
                  <Col span="3">
                    {/* {viewMode && (
            <Button type="link" onClick={() => setViewMode(false)} style={{ fontWeight:'normal',fontSize: 24,color:'#000',float: 'left' }}>
               <EditOutlined /> &nbsp;Edit
            </Button>
          )} */}
                  </Col>
                </Row>

              </Form>


              {/* <Form
             // form={formDr}
              ref={formRef}
             // ref={(form)=>formRef=form}
              layout="vertical"
               labelCol={{ span: 16 }}
               wrapperCol={{ span: 20}}
               onFinish={handleFinishDr}
              //  onFinish={onFinish}
              //  onFinishFailed={onFinishFailed}
              > */}
              <Row style={{ backgroundColor: "#ffffff", paddingBottom: 80, borderLeft: '1px solid #dfe0eb', borderRight: '1px solid #dfe0eb', borderBottom: '1px solid #dfe0eb', marginBottom: 10 }}>
                <Col span="3"></Col>
                <Col span="18"  >
                  <br />
                  <>
                    {/* <Form.Item > */}
                    {/* <Row  style={{width:'100%'}}><Col span={12}> <h2 className="directorateHeading"> Directorate</h2></Col><Col style={{textAlign:'right'}} span={12}><Button style={{marginBottom:-2,marginTop:-5,padding:0,fontSize:18,fontWeight:500}}   ref={inputAddBranch} type="link">+ ADD  DIRECTORATE</Button></Col></Row> */}
                    <Form
                      // form={formDr}
                      ref={formDrRef}
                      // ref={(form)=>formRef=form}
                      layout="vertical"
                      labelCol={{ span: 24 }}
                      wrapperCol={{ span: 24 }}
                      onFinish={handleDrSubmit}
                    //  onFinish={onFinish}
                    //  onFinishFailed={onFinishFailed}
                    >
                      <Form.List name="bd_directorates_add" >
                        {(fields, { add, remove }) => (
                          <>
                            <Form.Item >
                              <Row style={{ width: '100%' }}><Col span={12}> <h2 style={{ fontWeight: 'bold', fontStyle: 'normal', fontSize: 22 }}> Directorate</h2><a className={'directorateCount-a'}>{bDirectorate && bDirectorate.length} {bDirectorate && bDirectorate.length > 1 ? 'Directorates' : 'Directorate'}</a></Col><Col style={{ textAlign: 'right' }} span={12}> <Can I="manageB" a="add"> <Button style={{ marginBottom: -2, marginTop: -5, padding: 0, fontSize: 18, fontWeight: 500 }} onClick={() => add()} ref={inputAddBranch} type="link">+ ADD  DIRECTORATE</Button></Can></Col></Row>
                            </Form.Item>
                            {fields.map(({ key, name, fieldKey, ...restField }) => (
                              <>
                                <Form.Item >
                                  {/* <h2 style={{fontWeight:'400',fontStyle:'normal',fontSize:20}}> Directorate {key+1} &nbsp;&nbsp;<MinusCircleOutlined onClick={() => remove(name)}  /></h2> */}
                                  <h2 style={{ fontWeight: '400', fontStyle: 'normal', fontSize: 20 }}> Directorate {bDirectorate && bDirectorate.length + key + 1}</h2>
                                </Form.Item>
                                {/* <Form.Item  style={{ marginBottom: 0 }}> */}

                                <Form.Item
                                  {...restField}
                                  name={[name, 'name']}
                                  rules={[{ required: true, message: 'Name is required' }]}
                                  requiredMark={'optional'}
                                  //style={{ display: 'inline-block', width: 'calc(50% - 8px)' }}
                                  label={<p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0 }}>Name*</p>}  >
                                  <Input className="formInput" placeholder="" />
                                </Form.Item>

                                <Form.List name={[name, 'arr_bdreferenceNumber']} initialValue={[{ referenceNumber: '' }]}>

                                  {(arr_bdreferenceNumber, { add, remove }) => (
                                    <>
                                      {arr_bdreferenceNumber.map(({ key, name, fieldKey, ...brestField }) => (
                                        <Form.Item style={{ marginBottom: 0 }}>

                                          <Form.Item
                                            {...brestField}
                                            name={[name, 'referenceNumber']}
                                            rules={[{ required: true, message: 'Reference No is required' }]}
                                            requiredMark={'optional'}
                                            style={{ display: 'inline-block', width: 'calc(50% - 8px)', marginRight: 5 }}
                                            // label={key==0 ?<Row style={{width:'100%'}}><Col span={18}><p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,marginTop:15}}>Reference No*</p></Col><Col style={{textAlign:'right'}} span={6}><Button style={{marginBottom:-2,marginTop:12,padding:0,fontSize:18,fontWeight:500}} onClick={() => add()} type="link">+ ADD</Button></Col></Row>: <Row style={{width:'100%',marginBottom:-25}}><Col span={18}><p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,marginTop:15}}>Reference No*</p></Col><Col style={{textAlign:'right'}} span={6}><Button style={{marginBottom:-2,marginTop:12,padding:0,fontSize:18,fontWeight:500}} onClick={() => remove(name)} type="link"><MinusCircleOutlined  /></Button></Col></Row>}
                                            label={<p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0, marginTop: 15 }}>Reference No*</p>}
                                          // fieldKey={[bdreferenceNumber.fieldKey, 'ref']}
                                          // rules={[{ required: true, message: 'Reference No is required' }]}
                                          // requiredMark={'optional'}
                                          >
                                            <Input className="formInput" placeholder="" />
                                          </Form.Item>


                                          <Form.Item
                                            //name={'description'}
                                            {...brestField}
                                            name={[name, 'description']}
                                            style={{ display: 'inline-block', width: 'calc(50% - 8px)' }}
                                            label={key == 0 ? <Row style={{ width: '100%' }}><Col span={18}><p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0, marginTop: 15 }}>Description</p></Col><Col style={{ textAlign: 'right' }} span={6}><Button style={{ marginBottom: 0, marginTop: 2, padding: 0, fontSize: 18, fontWeight: 500 }} onClick={() => add()} type="link">+ ADD</Button></Col></Row> : <Row style={{ width: '100%', marginBottom: -25 }}><Col span={18}><p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0, marginTop: 15 }}>Description</p></Col><Col style={{ textAlign: 'right' }} span={6}><Button style={{ marginBottom: -2, marginTop: 12, padding: 0, fontSize: 18, fontWeight: 500 }} onClick={() => remove(brestField.name)} type="link"><MinusCircleOutlined /></Button></Col></Row>}
                                          // fieldKey={[bdreferenceNumber.fieldKey, 'description']}
                                          // label={<p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,marginTop:15}}>Description</p>}ADD
                                          >

                                            <TextArea style={{ lineHeight: 1.2 }} rows={0} className="formInput" placeholder="" />
                                          </Form.Item>

                                          {/* <Form.Item
                                          {...brestField}
                                          name={[name, 'referenceNumber']}
                                          rules={[{ required: true, message: 'Reference No is required' }]}
                                          requiredMark={'optional'}
                                          //style={{ display: 'inline-block', width: key==0?'calc(50% - 8px)':'99%', margin: key==0?'0 8px':0 }}
                                          label={key == 0 ? <Row style={{ width: '100%' }}><Col span={18}><p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0, }}>Reference No*</p></Col><Col span={6} style={{ textAlign: 'right' }}> <Button style={{ marginBottom: -5, marginTop: -10, padding: 0, fontSize: 18, fontWeight: 500 }} onClick={() => add()} type="link">+ ADD</Button></Col></Row> : <Row style={{ width: '100%' }}><Col span={18}><p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0, }}>Reference No*</p></Col><Col span={6} style={{ textAlign: 'right' }}><MinusCircleOutlined onClick={() => remove(name)} /></Col></Row>}
                                        //style={{ display: 'inline-block', width: '98%', margin: '0 8px' }}
                                        //label={<Row  style={{width:'100%'}}><Col span={18}><p style={{fontStyle:'normal',fontWeight:'normal',fontSize:16,color:'#6B778C',marginBottom:0,}}>Reference No*</p></Col><Col style={{textAlign:'right',paddingRight:1}} span={6}>&nbsp;&nbsp;<MinusCircleOutlined onClick={() => remove(name)}  /></Col></Row>}
                                        >
                                          <Input className="formInput" placeholder="" />
                                        </Form.Item> */}




                                        </Form.Item>
                                      ))}

                                    </>
                                  )}

                                </Form.List>

                                {/* </Form.Item> */}

                                {/* <Form.Item
                                  {...restField}
                                  name={[name, 'description']}
                                  label={<p style={{ fontStyle: 'normal', fontWeight: 'normal', fontSize: 16, color: '#6B778C', marginBottom: 0, marginTop: 15 }}>Description</p>}
                                >
                                  <TextArea rows={4} className="formInput" placeholder="" />
                                </Form.Item> */}
                                <>
                                </>
                                <Form.Item >
                                  {fields.length > 0 &&
                                    <Row style={{ paddingTop: 24, paddingBottom: 24, marginBottom: 10 }}>
                                      <Col span="24" style={{ textAlign: 'right' }}>
                                        <Space>
                                          <Button onClick={() => remove(name)} type="primary" size="large" ghost>Cancel</Button>&nbsp;
                                          {/* <Button htmlType="submit" type="primary" size="large" >Submit</Button> */}
                                          <Button htmlType="submit" type="primary" size="large" disabled={pending}>
                                            {pending ? 'Submiting...' : 'Submit'}
                                          </Button>
                                        </Space>
                                      </Col>
                                    </Row>
                                  }

                                </Form.Item>
                              </>
                            ))}

                          </>
                        )}
                      </Form.List>
                    </Form>

                    <Form
                      // form={formDr}
                      ref={formRef}
                      // ref={(form)=>formRef=form}
                      layout="vertical"
                      labelCol={{ span: 16 }}
                      wrapperCol={{ span: 24 }}
                      onFinish={handleFinishDr}
                    //  onFinish={onFinish}
                    //  onFinishFailed={onFinishFailed}
                    >
                      <Form.Item >
                        <Collapse
                          className='aaaaaa'
                          //defaultActiveKey={['1']}
                          onChange={callback}
                          expandIconPosition={'right'}
                          // activeKey={openPanel}
                          destroyInactivePanel={true}
                          accordion
                        >
                          <>
                            {bDirectorate && bDirectorate.length &&
                              <>
                                {bDirectorate.map(function (v, i) {
                                  // return <Panel header={capitalizeFirstLetter(v.bd_name)} key={i} extra={genExtra()}>
                                  // return <Panel header={panelHeader(v)} key={i} extra={genExtra()}>
                                  return <Panel header={panelHeader(v)} key={i} className='view-branch-directorate-clps-itm'>
                                    {/* <div>{v.bd_description?v.bd_description[0]:''}</div> */}
                                    <Form.Item
                                      name={'directorate_name'}
                                      hidden={true}
                                      className='faltu'
                                      initialValue={v.bd_name}
                                    >
                                      <Input className="formInput" placeholder="" />
                                    </Form.Item>

                                    <FormBuilder form={formDr} getMeta={() => getMetaDr(v)} viewMode={viewModeDr} />
                                    {!viewModeDr && (
                                      <Form.Item className="form-footer" wrapperCol={{ span: 24, offset: 0 }}>
                                        {/* <Button htmlType="submit" type="primary" disabled={pending}>
                                    {pending ? 'Updating...' : 'Update'}
                                  </Button> */}
                                        <Button
                                          type="primary"
                                          onClick={() => {
                                            formRef.current.resetFields();
                                            resetDr(branchname)
                                            setViewModeDr(true)
                                          }}
                                          style={{ marginLeft: '0px' }}
                                        >
                                          Cancel
                                        </Button>
                                      </Form.Item>
                                    )}
                                  </Panel>;
                                })}
                              </>
                            }
                          </>
                        </Collapse>
                      </Form.Item>
                    </Form>
                    {/* </Form.Item> */}

                  </>

                </Col>
                <Col span="3"></Col>
              </Row>

              {/* <Row  style={{paddingTop:24,paddingBottom:24,borderLeft:'1px solid #dfe0eb',borderRight:'1px solid #dfe0eb',borderBottom:'1px solid #dfe0eb',marginBottom:10}}>
         <Col span="6"></Col>
         <Col span="11" style={{textAlign:'right',marginLeft:12}}>
         <Space>
       <Link to="/departments"><Button  type="primary" size="large" ghost>Cancel</Button></Link>
         <Button htmlType="submit" type="primary" size="large" >Submit</Button>
       </Space>
         </Col>
         <Col span="6"></Col>
         
         </Row> */}
              {/* </Form> */}
            </div>

          </div>

        </div>
      </Container>
    </>
  );
}
